import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.REACT_APP_NAVIGATE(`/category/rexue?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20artistic%20illustration%2C%20vibrant%20colorful%20sky%20with%20cherry%20blossom%20petals%2C%20silhouettes%20of%20anime%20characters%20in%20dynamic%20poses%2C%20warm%20orange%20and%20pink%20gradient%20sunset%2C%20abstract%20geometric%20patterns%2C%20clean%20composition%2C%2C%20stylized%20illustration%20style&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="91动漫 - 正版高清动漫在线观看平台"
        title="91动漫 - 二次元追番首选平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
            正版高清动漫在线观看平台
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-[600px] mx-auto leading-relaxed">
            海量正版高清动漫资源，每日更新最新番剧。热血、恋爱、奇幻、搞笑——总有一部让你心动
          </p>

          <form onSubmit={handleSearch} className="max-w-[560px] mx-auto mb-8">
            <div className="relative flex items-center">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索你喜欢的番剧..."
                className="w-full h-14 pl-6 pr-32 text-sm rounded-2xl bg-white/95 backdrop-blur-sm border-0 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 text-sm"
              />
              <button
                type="submit"
                className="absolute right-2 h-10 px-6 text-sm font-medium rounded-xl bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line mr-1.5"></i>
                搜索
              </button>
            </div>
          </form>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/category/rexue"
              className="px-6 py-2.5 text-sm font-medium rounded-full bg-white/15 text-white backdrop-blur-sm hover:bg-white/25 transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              热血动漫
            </Link>
            <Link
              to="/category/lianai"
              className="px-6 py-2.5 text-sm font-medium rounded-full bg-white/15 text-white backdrop-blur-sm hover:bg-white/25 transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              恋爱动漫
            </Link>
            <Link
              to="/category/qihuan"
              className="px-6 py-2.5 text-sm font-medium rounded-full bg-white/15 text-white backdrop-blur-sm hover:bg-white/25 transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              奇幻动漫
            </Link>
            <Link
              to="/category/gaoxiao"
              className="px-6 py-2.5 text-sm font-medium rounded-full bg-white/15 text-white backdrop-blur-sm hover:bg-white/25 transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              搞笑动漫
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8 text-white/60 text-xs">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-shield-check-line text-sm"></i>
              正版授权
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-hd-line text-sm"></i>
              高清画质
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-speed-up-line text-sm"></i>
              流畅播放
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-smartphone-line text-sm"></i>
              多端支持
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}